import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormControl, Grid, makeStyles, MenuItem, Select, Typography } from '@material-ui/core';
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { enviarPDFSolicitud, imprimirPDFSolicitud } from '../../../actions/autorizaciones/Autorizaciones';
import { ModalPagoCoseguro } from '../gestionAuditoria/ModalPagoCoseguro';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS } from '../../../utils/constants';

const useStyles = makeStyles(() => ({
    formControl: {
        marginLeft: 25,
        marginRight: 40,
        minWidth: 50,
        maxWidth: 600
    },
}));

const AutorizacionesCoseguroImpresion = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [openModalPago, setOpenModalPago] = useState(false);
    const [opcionesSolicitud, setOpcioneSolicitud] = React.useState(2);
    const [periodo, setPeriodo] = React.useState(0);
    const { solicitudSeleccionada = {} } = useSelector((state) => state.autorizaciones);
    const [redirect, setRedirect] = useState(false);

    const handleClose = () => {
        if (props.redirectHome)
            setRedirect(true);
        else
            props.closeModalHandler();
    };

    const opciones = [
        { id: 1, display: 'Abonar Coseguro' },
        { id: 2, display: 'Imprimir Solicitud' },
        { id: 4, display: 'Imprimir Solicitud (con materiales)' },
        { id: 3, display: 'Enviar solicitud al Afiliado' }
    ];

    const opcionesConst = {
        ABONAR_COSEGURO: 1,
        IMPRIMIR_SOLICITUD: 2,
        ENVIAR_SOLICITUD: 3,
        IMPRIMIR_SOLICITUD_CON_MAT: 4,
    };

    const handleSubmit = () => {
        if (opcionesSolicitud === opcionesConst.ABONAR_COSEGURO) {
            setOpenModalPago(true);
        } else if (opcionesSolicitud === opcionesConst.IMPRIMIR_SOLICITUD || opcionesSolicitud === opcionesConst.IMPRIMIR_SOLICITUD_CON_MAT) {
            dispatch(imprimirPDFSolicitud(solicitudSeleccionada?.idSolicitud,
                solicitudSeleccionada?.idEstadoSolicitud ? solicitudSeleccionada?.idEstadoSolicitud
                : AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA, periodo,
                opcionesSolicitud === opcionesConst.IMPRIMIR_SOLICITUD));
        } else {
            dispatch(enviarPDFSolicitud(solicitudSeleccionada?.idSolicitud, periodo));
        }
    };

    const handleChangeSelect = (e) => {
        setOpcioneSolicitud(e.target.value);
    };

    const handleChangePeriodo = (e) => {
        setPeriodo(e.target.value);
    };
    console.log(props)
    return (
        <>
            {openModalPago &&
                <ModalPagoCoseguro
                    open={openModalPago}
                    handleCloseModalCoseguroImpresion={handleClose}
                    idSolicitud={solicitudSeleccionada.idSolicitud}
                    closeModalHandler={() => setOpenModalPago(false)}
                    importeCoseguros={solicitudSeleccionada.importeCobrarCoseguro}
                    filtros={props.filtros}
                />
            }
            <Dialog
                fullWidth
                maxWidth="sm"
                open={props.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Solicitud N° " + solicitudSeleccionada?.idSolicitud}</DialogTitle>
                <FormControl className={classes.formControl}>
                    <Grid style={{display:'flex',justifyContent: "space-between"}}>
                        <Grid item xs={6}>
                        <Typography>Opciones</Typography>
                        <Select
                            labelId="impSolLabel"
                            id="impSolSelect"
                            name="impSol"
                            value={opcionesSolicitud}
                            onChange={handleChangeSelect}
                        >
                            {solicitudSeleccionada.requiereCobroCab
                                // ? opciones.filter(o => o.id === opcionesConst.ABONAR_COSEGURO).map((t) => (
                                ? opciones.map((t) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        {t.display}
                                    </MenuItem>
                                ))
                                : opciones.filter(o => o.id !== opcionesConst.ABONAR_COSEGURO).map((t) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        {t.display}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                        </Grid>
                        {props.esDenunciaInternacionDomiciliaria && 
                        <Grid item xs={6}>
                            <Typography>Seleccione Periodo</Typography>
                        <Select
                            labelId="selectPeriodoLabel"
                            id="selectPeriodo"
                            name="selPeriodo"
                            value={periodo}
                            onChange={handleChangePeriodo}
                        >
                            {
                                props.periodos.map((t) => (
                                    <MenuItem key={t} value={t}>
                                        {t}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                        </Grid>
}
                    </Grid>
                </FormControl>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            {redirect && (
                <Redirect
                    to={{
                        pathname: "/autorizaciones",
                    }}
                />
            )}
        </>
    )
}

export default AutorizacionesCoseguroImpresion